"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partnership = void 0;
exports.Partnership = {
    EY: 'ey',
};
